export function isExternalPage(pageType) {
  return pageType === 'External';
}